import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Home, Compass, Wallet, Map, User } from 'lucide-react';

const BottomNav = () => {
    const location = useLocation();

    const navItems = [
        { icon: Home, label: 'Home', path: '/' },
        { icon: Compass, label: 'Explore', path: '/features' },
        { icon: Wallet, label: 'Wallet', path: '/wallet' },
        { icon: Map, label: 'Roadmap', path: '/roadmap' },
        { icon: User, label: 'About', path: '/about' },
    ];

    const isActive = (path) => location.pathname === path;

    return (
        <nav className="fixed bottom-0 left-0 right-0 z-50 lg:hidden">
            {/* Subtle gradient fade */}
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent pointer-events-none" />

            {/* Nav container - more transparent */}
            <div className="relative px-4 pb-3 pt-2">
                <div className="flex items-center justify-around bg-black/20 backdrop-blur-2xl rounded-2xl border border-white/5 mx-auto max-w-sm">
                    {navItems.map((item) => (
                        <Link
                            key={item.path}
                            to={item.path}
                            className="relative flex-1 py-2.5"
                        >
                            <motion.div
                                className="flex flex-col items-center"
                                whileTap={{ scale: 0.9 }}
                            >
                                {/* Active indicator line */}
                                {isActive(item.path) && (
                                    <motion.div
                                        layoutId="activeTab"
                                        className="absolute -top-0.5 w-5 h-0.5 bg-gradient-to-r from-[#FF6B00] to-[#FFB800] rounded-full"
                                        transition={{ type: 'spring', stiffness: 300, damping: 30 }}
                                    />
                                )}

                                <item.icon
                                    className={`w-[18px] h-[18px] transition-all duration-200 ${isActive(item.path)
                                        ? 'text-[#FF6B00]'
                                        : 'text-gray-500'
                                        }`}
                                    strokeWidth={isActive(item.path) ? 2.5 : 1.5}
                                />

                                <span className={`text-[9px] mt-0.5 transition-all duration-200 ${isActive(item.path)
                                    ? 'text-[#FF6B00] font-semibold'
                                    : 'text-gray-500 font-medium'
                                    }`}>
                                    {item.label}
                                </span>
                            </motion.div>
                        </Link>
                    ))}
                </div>
            </div>
        </nav>
    );
};

export default BottomNav;
